import { render, staticRenderFns } from "./ChangeGradeModal.vue?vue&type=template&id=6e333e0e&"
import script from "./ChangeGradeModal.vue?vue&type=script&lang=ts&"
export * from "./ChangeGradeModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports